// Activity
export const GET_ACTIVITY_REQUEST: string = "GET_ACTIVITY_REQUEST";
export const UPDATE_LIST_ACTIVITY: string = "UPDATE_LIST_ACTIVITY";
export const CLEAR_ACTIVITY: string = "CLEAR_ACTIVITY";

export const SET_LOADING: string = "SET_LOADING";
export const SET_LOADING_MORE: string = "SET_LOADING_MORE";
export const SET_CAN_LOAD_MORE: string = "SET_CAN_LOAD_MORE";
